import Form from "../../components/form/form";
import Joi from "joi-browser";
import React from "react";
import auth from "../../services/authService";
import { toast } from "react-toastify";
import { getSerialTypes } from "../../constants/serialTypes-constant";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";

export default class signUp extends Form {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            isLoading: false,
            serialTypesCategories: [...getSerialTypes()],
            isSerialTypeCategoriesSelected: false,
            selectedSerilType: "null",
            showSuccessMessage: "",
        };
    }
    state = {
        data: { mobile: "", nationalCode: "", name: "", serialType: 0, serial: "" },
        errors: {},
    };

    schema = {
        mobile: Joi.string().required().error(new Error("شماره تلفن همراه اجباری است")),
        name: Joi.string().error(new Error("نام اجباری است")),
        nationalCode: Joi.string().allow(null).allow('').optional(),
        serial: Joi.string().allow(null).allow('').optional(),
        serialType: Joi.string(),
        serialTypeId: Joi.string(),
    };

    doSubmit = async () => {
        const { data } = this.state;
        try {
            await auth.signUp(
                data.mobile,
                data.nationalCode,
                data.name,
                data.serialType,
                data.serial
            );
            const isLoading = false;
            const showSuccessMessage = true;
            this.setState({ isLoading: isLoading });
            this.setState({ showSuccessMessage: showSuccessMessage });
        } catch (ex) {
            console.log("ex : ", ex);
            if (ex.code !== "ERR_NETWORK") {
                if (ex.response.data.Message === undefined)
                    toast.error("خطای پیش بینی نشده");
                else toast.error(ex.response.data.Message);
            }
            const isLoading = false;
            this.setState({ isLoading: isLoading });
        }
    };

    handleSerialTypeCategoriesSelect = (serialType) => {
        this.setState({ selectedSerilType: serialType.value }, () => {
            this.state.data.serialType = serialType.label;
            this.state.data.serialTypeId = serialType.id;
        });
    };

    render() {
        if (auth.getCurrentUser()) return (window.location = "/");
        return (
            <div id="loginByMobile">
                <div className="row justify-content-center">
                    <form
                        onSubmit={this.handleSubmit}
                        className="row justify-content-center"
                        action="/"
                    >
                        <div className="col-11  mb-4">
                            <small style={{ color: "red" }}>اجباری</small>
                            {this.renderInput("mobile", "", "شماره تلفن همراه", "form-control form-control-lg")}
                        </div>
                        <div className="col-11  mb-4">
                            <small style={{ color: "red" }}>اجباری</small>
                            {this.renderInput("name", "", "نام", "form-control form-control-lg")}
                        </div>
                        <label className="row justify-content-center">
                            در صورتیکه هر کدام از اطلاعات زیر را وارد نمایید ثبت نام شما
                            سریعتر انجام خواهد شد.
                        </label>
                        <div className="col-11  mb-4">
                            {this.renderInput("nationalCode", "", "شناسه ملی شرکت - کد ملی شخص", "form-control form-control-lg")}
                        </div>
                        <div className="col-11 mb-4">
                            <label className="visually-hidden" htmlFor="specificSizeSelect">
                                نوع دستگاه
                            </label>
                            <DropDownWhiteStyle
                                items={this.state.serialTypesCategories}
                                placeholder="نوع دستگاه"
                                onItemSelect={this.handleSerialTypeCategoriesSelect}
                            />
                        </div>

                        <div className="col-11  mb-4">
                            {this.renderInput(
                                "serial",
                                "",
                                "سریال محصول",
                                "form-control form-control-lg"
                            )}
                        </div>
                        <div className="d-grid  col-11 mx-auto">
                            {this.renderButtonWithSpinner("ثبت نام", "btn btn-primary")}
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
